import { Analytics } from '../../protocols/analytics'

export class MetaPixelAnalyticsProviderAdapter extends Analytics {
  constructor(pixelId) {
    super()
    this.pixelId = pixelId
    this.fbq = null
    this.initialized = false
    this.init()
  }

  init() {
    if (typeof window === 'undefined') {
      return
    }

    if (window.fbq) {
      this.fbq = window.fbq
      this.initialized = true
      return
    }

    this.loadScript()
  }

  loadScript() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return
    }

    ;(function (f, b, e, v, n, t, s) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    )

    if (window.fbq && this.pixelId) {
      window.fbq('init', this.pixelId)
      window.fbq('track', 'PageView')
      this.fbq = window.fbq
      this.initialized = true
    }
  }

  capture(eventName, properties = {}) {
    if (!this.fbq || !this.initialized) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.log('Meta Pixel is not available. Skipping event capture...')
      }
      return
    }

    try {
      this.fbq('trackCustom', eventName)
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.error('[Meta Pixel Tracker Error]:', error)
      }
    }
  }
}
